import {
  CaretRight,
  AddItemLarge,
  AddItemMedium,
  AddItemSmall,
  AddMedia,
  Help24,
  CheckboxChecked,
  CheckboxIndeterminate,
  Close,
  CloseLarge,
  DragAndDropLarge,
  DragAndDropSmall,
  Asterisk,
  DropDownArrow,
  FormFieldSpinnerUp,
  FormFieldSpinnerDown,
  FormFieldError,
  FormFieldErrorSmall,
  ToggleOn,
  ToggleOff,
  ToggleOnSmall,
  ToggleOffSmall,
  CircleLoaderCheck,
  CircleLoaderCheckSmall,
  FormFieldSuccessFilled,
  FormFieldWarningFilled,
  FormFieldErrorFilled,
  BreadcrumbsChevronRight,
  TextAreaBoldSmall,
  TextAreaBoldLarge,
  TextAreaItalicSmall,
  TextAreaItalicLarge,
  TextAreaUnderlineSmall,
  TextAreaUnderlineLarge,
  TextAreaLinkSmall,
  TextAreaLinkLarge,
  TextAreaBulletListSmall,
  TextAreaBulletListLarge,
  TextAreaNumberedListSmall,
  TextAreaNumberedListLarge,
  BreadcrumbsChevronRightSmall,
} from '@wix/wix-ui-icons-common/lazy/system';

import {
  Add,
  AddSmall,
  Search,
  SearchSmall,
  Location,
  ChevronDown,
  ChevronDownSmall,
  ChevronLeft,
  ChevronRight,
  ChevronLeftLarge,
  ChevronRightLarge,
  ChevronLeftLargeSmall,
  ChevronRightLargeSmall,
  ChevronLeftSmall,
  ChevronRightSmall,
  Confirm,
  ConfirmSmall,
  Pipette,
  LockUnlocked,
  LockLocked,
  RoundedCorner,
  Date,
  StatusAlertFilledSmall,
  StatusWarningFilledSmall,
  InfoCircle,
  InfoCircleSmall,
  StatusAlertSmall,
  StatusWarningSmall,
  Check,
  X,
  ArrowLeft,
  ArrowRight,
  ArrowUpSmall,
  ArrowDownSmall,
  ArrowLeftSmall,
  ArrowRightSmall,
  ArrowBentUpLeft,
  StatusAlert,
  StatusComplete,
  StatusWarning,
  StatusCompleteFilled,
  Favorite,
  FavoriteFilled,
  StatusAlertFilled,
  StatusWarningFilled,
  InfoCircleFilled,
  PlayFilled,
  PauseFilled,
  Delete,
  Download,
  More,
  Replace,
  Link,
  TextColor,
  TrendingSmall,
  DownwardtrendSmall,
} from '@wix/wix-ui-icons-common/lazy';

export const defaultIcons = {
  AccordionItemCaret: {
    CaretRight: CaretRight,
  },
  AudioPlayer: {
    PlayFilled: PlayFilled,
    PauseFilled: PauseFilled,
  },
  AutoCompleteWithLabel: {
    StatusAlertSmall: StatusAlertSmall,
  },
  BadgeSelect: {
    ChevronDownSmall: ChevronDownSmall,
  },
  AddItem: {
    Add: Add,
    AddItemLarge: AddItemLarge,
    AddItemMedium: AddItemMedium,
    AddItemSmall: AddItemSmall,
    AddMedia: AddMedia,
  },
  AddressInput: {
    Search: Search,
  },
  AddressInputItem: {
    Location: Location,
  },
  BaseModalLayout: {
    Help24: Help24,
  },
  Breadcrumbs: {
    BreadcrumbsChevronRight: BreadcrumbsChevronRight,
    BreadcrumbsChevronRightSmall: BreadcrumbsChevronRightSmall,
  },
  Carousel: {
    ChevronLeftLarge: ChevronLeftLarge,
    ChevronRightLarge: ChevronRightLarge,
    ChevronLeftLargeSmall: ChevronLeftLargeSmall,
    ChevronRightLargeSmall: ChevronRightLargeSmall,
    ChevronLeftSmall: ChevronLeftSmall,
    ChevronRightSmall: ChevronRightSmall,
  },
  DatePickerDropdown: {
    ChevronDown: ChevronDown,
  },
  DatePickerHead: {
    ChevronLeftLarge: ChevronLeftLarge,
    ChevronRightLarge: ChevronRightLarge,
    ChevronLeftSmall: ChevronLeftSmall,
    ChevronRightSmall: ChevronRightSmall,
  },
  CarouselWIP: {
    ChevronLeftSmall: ChevronLeftSmall,
    ChevronRightSmall: ChevronRightSmall,
  },
  Checkbox: {
    CheckboxChecked: CheckboxChecked,
    CheckboxIndeterminate: CheckboxIndeterminate,
  },
  CheckToggle: {
    Confirm: Confirm,
    ConfirmSmall: ConfirmSmall,
  },
  CircularProgressBar: {
    StatusCompleteFilled: StatusCompleteFilled,
    CircleLoaderCheckSmall: CircleLoaderCheckSmall,
    CircleLoaderCheck: CircleLoaderCheck,
    StatusAlertFilled: StatusAlertFilled,
    FormFieldErrorSmall: FormFieldErrorSmall,
    FormFieldError: FormFieldError,
  },
  CloseButton: {
    Close: Close,
    CloseLarge: CloseLarge,
  },
  ColorPickerActions: {
    Check: Check,
    X: X,
  },
  ColorPickerConverter: {
    Pipette: Pipette,
  },
  ColorPickerConverterViewer: {
    AddSmall: AddSmall,
  },
  ColorPickerEyeDropper: {
    Pipette: Pipette,
  },
  ComposerHeader: {
    ArrowLeft: ArrowLeft,
  },
  CornerRadiusInputLinkingButton: {
    LockUnlocked: LockUnlocked,
    LockLocked: LockLocked,
  },
  CornerRadiusInputField: {
    RoundedCorner: RoundedCorner,
  },
  DateInput: {
    Date: Date,
  },
  Dock: {
    ArrowUpSmall: ArrowUpSmall,
    ArrowRightSmall: ArrowRightSmall,
    ArrowDownSmall: ArrowDownSmall,
    ArrowLeftSmall: ArrowLeftSmall,
  },
  DragHandle: {
    DragAndDropLarge: DragAndDropLarge,
    DragAndDropSmall: DragAndDropSmall,
  },
  EditableRow: {
    Check: Check,
    X: X,
  },
  EditableSelector: {
    Add: Add,
    Delete: Delete,
  },
  FieldSetAsterisk: {
    Asterisk: Asterisk,
  },
  FieldSetStatusMessage: {
    StatusAlertFilledSmall: StatusAlertFilledSmall,
    StatusWarningFilledSmall: StatusWarningFilledSmall,
  },
  FilePicker: {
    Add: Add,
  },
  FillButton: {
    Add: Add,
    AddSmall: AddSmall,
  },
  FormField: {
    Asterisk: Asterisk,
    StatusAlertFilledSmall: StatusAlertFilledSmall,
    StatusWarningFilledSmall: StatusWarningFilledSmall,
  },
  GoogleAddressInput: {
    Search: Search,
  },
  HorizontalScroll: {
    ChevronLeftSmall: ChevronLeftSmall,
    ChevronRightSmall: ChevronRightSmall,
  },
  ImageViewer: {
    Delete: Delete,
    Download: Download,
    More: More,
    Replace: Replace,
  },
  InfoIcon: {
    InfoCircle: InfoCircle,
    InfoCircleSmall: InfoCircleSmall,
  },
  InputShell: {
    DropDownArrow: DropDownArrow,
  },
  InputSuffix: {
    DropDownArrow: DropDownArrow,
  },
  InputTicker: {
    FormFieldSpinnerUp: FormFieldSpinnerUp,
    FormFieldSpinnerDown: FormFieldSpinnerDown,
  },
  InputWithLabel: {
    StatusAlertSmall: StatusAlertSmall,
    StatusWarningSmall: StatusWarningSmall,
  },
  InputWithTags: {
    DropDownArrow: DropDownArrow,
  },
  LinearProgressBar: {
    ToggleOn: ToggleOn,
  },
  ListItemEditable: {
    Check: Check,
    X: X,
  },
  Loader: {
    FormFieldError: FormFieldError,
    FormFieldErrorSmall: FormFieldErrorSmall,
    ToggleOn: ToggleOn,
    CircleLoaderCheck: CircleLoaderCheck,
    CircleLoaderCheckSmall: CircleLoaderCheckSmall,
  },
  Modal: {
    ArrowLeft: ArrowLeft,
    ArrowRight: ArrowRight,
  },
  ModalMobileLayout: {
    X: X,
  },
  ModalPreviewLayout: {
    X: X,
  },
  NavigationButton: {
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
  },
  NavigationToast: {
    ArrowBentUpLeft: ArrowBentUpLeft,
  },
  NestableList: {
    Add: Add,
  },
  PageHeader: {
    ChevronLeft: ChevronLeft,
  },
  Pagination: {
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
  },
  RichTextInputAreaForm: {
    Check: Check,
    X: X,
  },
  RichTextToolbar: {
    TextAreaBoldSmall: TextAreaBoldSmall,
    TextAreaBoldLarge: TextAreaBoldLarge,
    TextAreaItalicSmall: TextAreaItalicSmall,
    TextAreaItalicLarge: TextAreaItalicLarge,
    TextAreaUnderlineSmall: TextAreaUnderlineSmall,
    TextAreaUnderlineLarge: TextAreaUnderlineLarge,
    TextAreaLinkSmall: TextAreaLinkSmall,
    TextAreaLinkLarge: TextAreaLinkLarge,
    TextAreaBulletListSmall: TextAreaBulletListSmall,
    TextAreaBulletListLarge: TextAreaBulletListLarge,
    TextAreaNumberedListSmall: TextAreaNumberedListSmall,
    TextAreaNumberedListLarge: TextAreaNumberedListLarge,
  },
  Search: {
    Search: Search,
    SearchSmall: SearchSmall,
  },
  SectionHelper: {
    InfoCircle: InfoCircle,
    StatusAlert: StatusAlert,
    StatusComplete: StatusComplete,
    StatusWarning: StatusWarning,
  },
  SidebarBackButton: {
    ChevronLeft: ChevronLeft,
  },
  SidebarNextToggleButton: {
    ChevronRightSmall: ChevronRightSmall,
    ChevronLeftSmall: ChevronLeftSmall,
  },
  SidebarSectionItem: {
    ChevronRight: ChevronRight,
  },
  SidebarSubMenuNextCommon: {
    ChevronRightSmall: ChevronRightSmall,
  },
  SidePanelHeader: {
    Help24: Help24,
    ChevronLeftLarge: ChevronLeftLarge,
  },
  SocialPreview: {
    Link: Link,
  },
  StatisticsItem: {
    InfoCircleSmall: InfoCircleSmall,
  },
  Step: {
    ChevronRight: ChevronRight,
  },
  StepMarker: {
    Confirm: Confirm,
    StatusAlertFilled: StatusAlertFilled,
    FormFieldErrorSmall: FormFieldErrorSmall,
  },
  ReadOnlyStarsRatingBar: {
    FavoriteFilled: FavoriteFilled,
  },
  InteractiveStarsRatingBar: {
    Favorite: Favorite,
    FavoriteFilled: FavoriteFilled,
  },
  RowStatusCell: {
    StatusAlertFilledSmall: StatusAlertFilledSmall,
    StatusWarningFilledSmall: StatusWarningFilledSmall,
  },
  StatusIndicator: {
    FormFieldSuccessFilled: FormFieldSuccessFilled,
    FormFieldWarningFilled: FormFieldWarningFilled,
    FormFieldErrorFilled: FormFieldErrorFilled,
  },
  StatusToast: {
    StatusCompleteFilled: StatusCompleteFilled,
    StatusAlertFilled: StatusAlertFilled,
    StatusWarningFilled: StatusWarningFilled,
    InfoCircleFilled: InfoCircleFilled,
  },
  TableActionCell: {
    ChevronRight: ChevronRight,
    More: More,
  },
  TableListItem: {
    CaretRight: CaretRight,
  },
  Thumbnail: {
    CheckboxChecked: CheckboxChecked,
  },
  TimeTable: {
    AddSmall: AddSmall,
  },
  ToggleButton: {
    ChevronLeftSmall: ChevronLeftSmall,
    ChevronRightSmall: ChevronRightSmall,
  },
  ToggleSwitch: {
    ToggleOn: ToggleOn,
    ToggleOff: ToggleOff,
    ToggleOnSmall: ToggleOnSmall,
    ToggleOffSmall: ToggleOffSmall,
    TextColor: TextColor,
  },
  TopBanner: {
    X: X,
  },
  TrendIndicator: {
    TrendingSmall: TrendingSmall,
    DownwardtrendSmall: DownwardtrendSmall,
  },
};
